import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VersionCheckComponent } from './versioncheck.component';
import { RefreshComponent } from './refresh/refresh.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [VersionCheckComponent, RefreshComponent],
  exports: [VersionCheckComponent]
})
export class VersionCheckModule { }
